export default {"src":"/_next/static/media/ph-cat.6aa5b0b3.svg","height":199,"width":200,"blurWidth":0,"blurHeight":0};